export default __webpack_public_path__ + "static/media/bottom_flowers.5b5e9066.png";